import { useSelector } from "react-redux";
import type { RootState } from "../store";
import type { User } from "../types/users";

export const useMe = (): User => {
  return useSelector((state: RootState) => state.auth.me);
};
